(function ($) {
  'use strict';

  window.ys.ThisIsEnough = new ThisIsEnough();
  /**
   * Initialize the quiz
   */
  if ($('body').hasClass('this_is_enough')) {
    window.ys.ThisIsEnoughContest = new ThisIsEnough.Contest();
  }
}).bind(window)(jQuery);
